module.exports = __webpack_public_path__ + "static/img/yellow_btn.5c8c8cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ja/yellow_btn.png
// module id = DLEk
// module chunks = 0